import * as React from "react";
import { useCallback, useEffect } from "react";
import Input from "components/bootstrap/Input";
import Select from "components/common/Select";
import { StaticSource } from "enterprise/parameters/components/option/OptionSource";
const DELIMITER = ",";
const parseOptions = (input) => input.split(DELIMITER).map((s) => s.trim()).filter((s) => s !== "");
const StaticSourceForm = ({
  onChange,
  idx,
  source,
  onValidate,
  validationState
}) => {
  var _a, _b;
  const _onChange = useCallback((newValues) => onChange(StaticSource.create(parseOptions(newValues))), [onChange]);
  const { values = [] } = source != null ? source : {};
  const options = values ? values.map((value) => ({ label: value, value })) : [];
  useEffect(() => {
    const _validationState = values !== void 0 && values.length > 0 ? ["success"] : ["error", "Please enter at least one option"];
    onValidate(idx, { "source.values": _validationState });
  }, [values, idx, onValidate]);
  useEffect(
    () => () => {
      onValidate(idx, { "source.values": ["success"] });
    },
    [idx, onValidate]
  );
  return /* @__PURE__ */ React.createElement(
    Input,
    {
      id: `values-${idx}`,
      name: "values",
      label: "Values",
      bsStyle: (_a = validationState == null ? void 0 : validationState["source.values"]) == null ? void 0 : _a[0],
      help: (_b = validationState == null ? void 0 : validationState["source.values"]) == null ? void 0 : _b[1]
    },
    /* @__PURE__ */ React.createElement(
      Select,
      {
        placeholder: "Please add options",
        inputId: "source-values-input",
        className: "source-values-input",
        onChange: _onChange,
        allowCreate: true,
        delimiter: DELIMITER,
        multi: true,
        value: values.join(DELIMITER),
        options
      }
    )
  );
};
export default StaticSourceForm;
